import { fulfilled, pending, rejected } from '../../../utils';
import { LOGIN } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
  message: '',
  data: '',
	error: '',
};

const loginReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(LOGIN):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(LOGIN):
			return {
				...state,
				loading: false,
				status: action?.payload?.data?.status,
				message: action?.payload?.data?.message,
				data: action?.payload?.data?.data,
				error: '',
			};
      case rejected(LOGIN):
        const status = action.payload.response.status
        return {
          ...state,
          loading: false,
          message: '',
          error: status ===500 ? "Something went wrong. Please try again" : action?.payload?.response?.data?.message,
        };
		default:
			return state;
	}
};

export default loginReducer;
